export default __webpack_public_path__ + "static/media/s3.af667088.jpg";